// extracted by mini-css-extract-plugin
module.exports = {"iframe":"FundDetailsPodcastTab_iframe__ialfg","accordion-item":"FundDetailsPodcastTab_accordion-item__0b2sl","btn":"FundDetailsPodcastTab_btn__E1uDy"};